import { UserManager, WebStorageStateStore } from 'oidc-client-ts'
import { PROD } from '../../../config/stage'

const stage = import.meta.env.VITE_STAGE
const authServiceStagePrefix = stage === PROD ? '' : 'test-'
const authServiceHost = `${authServiceStagePrefix}auth.eidu.com`
const authority = `https://${authServiceHost}/realms/eidu`

const userManager = new UserManager({
  authority,
  client_id: 'eidu-console',
  redirect_uri: window.location.origin + window.location.pathname,
  post_logout_redirect_uri: window.location.origin,
  scope: 'openid profile',
  // Token lifetime is 60s; default notification fires at 60s before expiry,
  // causing continuous renewal. Use 10s to avoid the loop.
  accessTokenExpiringNotificationTimeInSeconds: 10,
  userStore: new WebStorageStateStore({ store: sessionStorage }),
})

export default userManager
